<style lang="scss">
@import '../assets/scss/_variables';

#main-nav {
    width: 100%;
    padding: 0px #{$grid-size * 2};
    position: absolute;
        top: $grid-size * 2;
        left: 0;
        z-index: 2;

    transition: all $transition-nav-pull;
    pointer-events: none;

    &.is-pulled {
        top: 0px;
    }

    .left-button {
        margin-left: -16px; // to counter padding
        padding: 15px 20px;
        color: $color-black;
    }

        .fa-times {
            margin-top: 2px;
            margin-left: -4px;
            font-size: 24px;
        }

    a {
        padding: 20px 15px; // x for design, y for click area
        font-size: 16px;
        color: $color-text-2;

        &:hover {
            text-decoration: none;
        }
    }

    button, a {
        opacity: 1;
        pointer-events: all;

        transition:
            color $transition-hover,
            opacity $transition-hover;

        &:hover {
            opacity: 0.6;
        }
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .fade-enter-active {
        transition: opacity $transition-nav-button-fade;
    }

    .fade-leave-active {
        transition: opacity $transition-nav-button-fade-out;
    }

    &.slide-enter,
    &.slide-leave-to {
        top: -$grid-size * 2;
        opacity: 0;
    }
}

    .wrapper-nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: $grid-size * 2;
        margin: 0 auto;
    }

@include media-smaller('md') {
    #main-nav {
        padding: 0 $mobile-pad;
        top: 0;

        .right {
            margin: 0 -15px;
        }
    }
}
</style>

<template>
    <transition name="slide">
        <nav
            v-if="isVisible"
            id="main-nav"
            :class="{
                'is-pulled': pullNav
            }"
        >
            <div class="wrapper-nav">
                <div>
                    <transition name="fade">
                        <button class="left-button" v-if="canClose" @click="close">
                            <fa :icon="['fal', 'times']"></fa>
                        </button>
                    </transition>
                </div>

                <div class="right">
                    <router-link to="/about" v-if="route.name !== 'about'">
                        &mdash; About
                    </router-link>
                </div>
            </div>
        </nav>
    </transition>
</template>

<script>
export default {
    data () {
        return {
            route: null
        };
    },
    computed: {
        canClose () {
            return this.route.path !== '/';
        },
        pullNav () {
            return this.route.name === 'form';
        },
        isVisible () {
            return this.route.name !== 'results' && !this.$store.state.isLoading;
        }
    },
    methods: {
        close: function () {
            this.$router.go(-1);
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler: function (to, from) {
                this.route = to;
            }
        }
    }
};
</script>
